<div class="editor">
  <!-- Hiển thị tiêu đề mở rộng -->
  <div class="editor-header" *ngIf="isViewAll">
    <i class="bi bi-chevron-left" (click)="isViewAll = !isViewAll"></i>
    <span (click)="isViewAll = !isViewAll">{{ currentViewAll.title | translate }}</span>
  </div>

  <ng-container *ngIf="!isViewAll">
    <app-position-out-config [elementChoosing]="objectChoosing" [device]="device" [id_parent_choose]="
        objectChoosing.id_block
          ? objectChoosing.id_block
          : objectChoosing.id_object
      "></app-position-out-config>

    <app-width-height-config [width]="class['date-delivery']['width']"  [device]="device" 
    [elementChoosing]="objectChoosing" [height]="class['date-delivery']['height']"
    (changeWidthHeight)="changeWidthHeight($event)"></app-width-height-config>

    <ul nz-menu nzMode="inline" [nzInlineCollapsed]="isCollapsed">
      <li nz-submenu nzTitle="{{'thong_so_co_ban' | translate}}" [(nzOpen)]="openMap.menu1"
        (nzOpenChange)="openHandler('menu1')">
        <div class="config-text" style="width: 100%">
          <mat-form-field style="width: 100%">
            <mat-label>{{'noi_dung' | translate}}</mat-label>
            <textarea matInput
              [ngModel]="staticdata['placeholder_' + functionService.selectedLanguageCode] | vhLanguage : 'placeholder' : objectChoosing.component" 
              (ngModelChange)="staticdata['placeholder_' + functionService.selectedLanguageCode] = $event"
              (blur)="updateContent('placeholder')">
            </textarea>
          </mat-form-field>
        </div>

        <nz-select [(ngModel)]="objectChoosing.staticdata.format" (ngModelChange)="updateStaticData()"
          nzPlaceHolder="{{'chon_thoi_gian' | translate}}" nzAllowClear>
          <nz-option [nzValue]="'dd-MM-yyyy'" nzLabel="{{'ngay_thang_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'MM-dd-yyyy'" nzLabel="{{'thang_ngay_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'yyyy-MM-dd'" nzLabel="{{'nam_thang_ngay' | translate}}"></nz-option>
          <nz-option [nzValue]="'MM-yyyy'" nzLabel="{{'thang_nam' | translate}}"></nz-option>
          <nz-option [nzValue]="'yyyy'" nzLabel="{{'nam' | translate}}"></nz-option>
        </nz-select>
      </li>
      <!-- Cấu hình thông số cơ bản của button-->
      <li nz-submenu nzTitle="{{'hien_thi' | translate}}" [(nzOpen)]="openMap.menu2"
        (nzOpenChange)="openHandler('menu2')">
        <div class="button-size">
          <!-- Lựa chọn hiển thị cho các thiết bị -->
          <app-hide-show-config [device]="device" [elementChoosing]="objectChoosing">
          </app-hide-show-config>
        </div>
      </li>
    </ul>

    <!-- Cấu hình hình dạng viền -->
  </ng-container>

  <!-- Xem chi tiết cấu hình object -->
  <div class="view-more" *ngIf="isViewAll"></div>
</div>